import api from "../apps/api/v2/api"
import SpeakAudioForm from "../apps/api/v2/forms/speak_audio"

export const SPEAK_REGEX = /(<audio\s*.*>(.*\n*.*\n*)*<\/audio>)/i

export const SPEAK_LANG_REGEX = /(lang='*.*')/i

const DEFAULT_SOURCE_AUDIO = "https://s3.ap-northeast-1.amazonaws.com/qbase-feature/speak_audio/12345.c7d3cdd1-28d1-4d22-ab77-5385852749f6.mp3"

export function processAudioSpeak(parent: Document | Element = document, loadWhenPlay = false) {
    if (!parent) {
        return;
    }
    const elements = Array.from(parent.getElementsByTagName('audio'))

    const speakAutioEletmens: HTMLAudioElement[] = []
    elements.forEach(element => {
        if (processAudioSpeakElement(element, loadWhenPlay)) {
            speakAutioEletmens.push(element)
        }
    })
}

function processAudioSpeakElement(element: HTMLAudioElement, loadWhenPlay = false) {
    const type = element.getAttribute("type")

    if (type != "speak") {
        return false;
    }

    if (element.src) {
        return false;
    }
    const speakAudioForm = new SpeakAudioForm();

    // https://www.geeksforgeeks.org/how-to-strip-out-html-tags-from-a-string-using-javascript/
    var div = document.createElement("div");
    div.innerHTML = element.innerHTML;
    speakAudioForm.content = (div.textContent || div.innerText || "").trim();

    speakAudioForm.lang = element.getAttribute("lang");
    speakAudioForm.voice = element.getAttribute("voice");
    speakAudioForm.speed = element.getAttribute("speed");

    if (loadWhenPlay) {
        // Playクリックするときに、本物を取りに行くので、さきにデフォルトAudioをださないといけない
        element.src = DEFAULT_SOURCE_AUDIO;
        element.onplay = async () => {
            if (element.src == DEFAULT_SOURCE_AUDIO) {
                // Pause the placeholder immediately so the user never hears it. This play was
                // user-initiated, so the element is already unlocked for iOS; playing the real
                // audio after the async fetch is still allowed on the same unlocked element.
                element.pause()
                await loadAudio(element, speakAudioForm)
                element.play()
            }
        }
    } else {
        loadAudio(element, speakAudioForm)
    }
    return true
}

// API Call Here
async function loadAudio(element: HTMLAudioElement, speakAudioForm: SpeakAudioForm) {
    element.src = ""
    await api.speakAudio.create(speakAudioForm).then((audioSrc) => {
        element.src = audioSrc
        element.load()
    }).catch(() => {
        alert("不明エラー発生しました")
    })
}